import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createI18n } from 'vue-i18n';

import nl from './locales/nl.json';
import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';

const i18n = createI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: { nl, fr, en, de }
});

createApp(App).use(router).use(i18n).mount('#app')
